<form id="auth-form" [formGroup]="formGroup">
  <div class="auth-title">{{ 'AUTH.TWOFACTORAUTHENTICATION.TITLE' | translate | uppercase }}</div>
  <div class="auth-sub-title">
    <div>{{ verifyCodeLabelKey | translate }}</div>
    @if ((remainingTries | async); as remainingTries) {
      <div>
        @if (remainingTries < 3) {
          <span class="twofactor-nbtries">
            {{ 'AUTH.TWOFACTORAUTHENTICATION.ERRORS.RETRY' | translate: { remainingTries: remainingTries} }}
          </span>
        }
      </div>
    }
  </div>
  <div class="twofactor-digit-code">
    <aa-input-digit-code name="{{ CodeField }}" label="{{ CodeField }}" required formControlName="{{ CodeField }}"
      [updateWhen]="'blur'" (enter)="onSubmit()">
    </aa-input-digit-code>

    @if (showCodeRequiredError()) {
      <div class="field-error">
        {{ 'AUTH.VERIFYCODE.REQUIRED' | translate }}
      </div>
    }
  </div>
  <div class="twofactor-buttons">
    <aa-btn-action-secondary [btnText]="'AUTH.FORM.BUTTON' | translate" [cta]="onSubmit" [btnWidth]="'100%'">
    </aa-btn-action-secondary>
  </div>
</form>